import { Routes } from '@angular/router'
import { ChatWidgetComponent } from './chat/chat-widget/chat-widget.component'
import { ChatFullscreenComponent } from './chat/chat-fullscreen/chat-fullscreen.component'
import { ChatGuard } from './chat/chat.guard'
import { EmptyStateComponent } from './chat/empty-state/empty-state.component'
import { ChatFullscreenResolver } from './chat/chat-fullscreen/chat-fullscreen.resolver'

export const appRoutes: Routes = [
  { path: '', canActivate: [ChatGuard] , component: ChatWidgetComponent },
  { path: 'fullscreen', canActivate: [ChatGuard], component: ChatFullscreenComponent, resolve: { participante: ChatFullscreenResolver } },
  { path: 'empty-state', component: EmptyStateComponent },
  { path: '**', component: EmptyStateComponent }
]